import axios from 'axios';
import {Bcmath} from 'bcmath';
import moment from 'moment/moment';

const _formatMoney = (value, currency) => {
  return parseFloat(value)
    .toLocaleString('nl', { style: 'currency', currency });
};

const _fetchSelectData = async (route) => {
  const {data} = await axios.get(route);
  return data;
};

const _copyToClipboard = async (text) => {
  navigator.clipboard.writeText(text);
};

const _highlightClick = async (event, id = null) => {
  const element = id
    ? document.getElementById(id)
    : event.target;

  element.classList.add('text-indigo-500');

  setTimeout(() => {
    element.classList.remove('text-indigo-500');
  }, 180);
};

const _retry = async (times, closure, timeout) => {
  return new Promise((resolve, reject) => {
    const attempt = async (remaining) => {
      try {
        const result = await closure();
        resolve(result);
      } catch (e) {
        if (remaining === 0) {
          reject(e);
        } else {
          setTimeout(() => attempt(remaining - 1), timeout);
        }
      }
    };

    attempt(times);
  });
};

const _bcmath = () => {
  return Bcmath(5);
};

const _allUrlParams = () => {
  const params = {};
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  urlParams.forEach((value, key) => {
    if (params[key]) {
      if (Array.isArray(params[key])) {
        params[key].push(value);
      } else {
        params[key] = [params[key], value];
      }
    } else {
      params[key] = value;
    }
  });

  return params;
};

const _defaultDateRangeConfig = () => {
  return {
    additionalPredefineds: [
      {
        key: 'next_month',
        after: 'last_week',
        label: 'Next month',
        from: moment().add(1, 'month').startOf('month'),
        to: moment().add(1, 'month').endOf('month'),
      },
      {
        key: 'month_to_day',
        after: 'last_month',
        label: 'MTD',
        from: moment().startOf('month'),
        to: moment().endOf('day'),
      },
      {
        key: 'last_month_to_day',
        after: 'month_to_day',
        label: 'Last MTD',
        from: moment().subtract(1, 'month').startOf('month'),
        to: moment().subtract(1, 'month').endOf('day'),
      },
      {
        key: 'year_to_day',
        after: 'last_month_to_day',
        label: 'YTD',
        from: moment().startOf('year'),
        to: moment().endOf('day'),
      },
      {
        key: 'last_year_to_day',
        after: 'year_to_day',
        label: 'Last YTD',
        from: moment().subtract(1, 'year').startOf('year'),
        to: moment().subtract(1, 'year').endOf('day'),
      },
      {
        key: 'last_year',
        after: 'this_year',
        label: 'Last Year',
        from: moment().subtract(1, 'year').startOf('year'),
        to: moment().subtract(1, 'year').endOf('year'),
      },
    ],
    timezone: window.Laravel.timezone,
  };
};

function _pushDataLayer (data){
  setTimeout(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  });
}

export function formatMoney(value, currency = 'EUR') {
  return _formatMoney(value, currency);
}

export async function fetchSelectData(route) {
  return _fetchSelectData(route);
}

export async function copyToClipboard(text) {
  return _copyToClipboard(text);
}

export async function highlightClick(event, id = null) {
  return _highlightClick(event, id);
}

export async function retry(times, closure, timeout = 2500) {
  return _retry(times, closure, timeout);
}

export function bcmath() {
  return _bcmath();
}

export function allUrlParams() {
  return _allUrlParams();
}

export function defaultDateRangeConfig() {
  return _defaultDateRangeConfig();
}

export function pushDataLayer(data) {
  return _pushDataLayer(data);
}

export default {
  methods: {
    async fetchSelectData(route) {
      return await _fetchSelectData(route);
    },
    formatMoney(value, currency = 'EUR') {
      return _formatMoney(value, currency);
    },
    copyToClipboard(text) {
      return _copyToClipboard(text);
    },
    highlightClick(event, id = null) {
      return _highlightClick(event, id);
    },
    retry(times, closure, timeout = 2500) {
      return _retry(times, closure, timeout);
    },
    bcmath() {
      return _bcmath();
    },
    allUrlParams() {
      return _allUrlParams();
    },
    defaultDateRangeConfig() {
      return _defaultDateRangeConfig();
    },
    pushDataLayer(data) {
      return _pushDataLayer(data);
    },
  },
};
